import { faCircleCheck as fasCircleCheck } from "@awesome.me/kit-3777c2145e/icons/classic/solid";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import type { ReactNode } from "react";
import { AbstractKkvStep } from "./AbstractKkvStep";

export class Result extends AbstractKkvStep {
	protected renderFields(): ReactNode {
		return (
			<div className="my-auto text-center">
				<FontAwesomeIcon icon={fasCircleCheck} className="text-success mb-3" size="4x" />
				<div className="h3 text-success text-uppercase mb-0">Sikeres kalkuláció!</div>
				<small className="text-success">Eredményeidet a lenti listában találod!</small>
			</div>
		);
	}

	protected getComponentName(): string {
		return "Result";
	}
}
